import * as React from 'react';

// BEEM lock icon (private visibility). Defaults to currentColor so it inherits the surrounding
// text color; pass `color` to tint it explicitly. Takes the size antd's `<Icon component>` passes
// (1em), so it scales with the surrounding font size there.
/** @param {{ color?: string, width?: number | string, height?: number | string }} [props] */
export default ({ color = 'currentColor', width = 24, height = 24 } = {}) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 2C14.7614 2 17 4.23858 17 7V10H18C19.1046 10 20 10.8954 20 12V20C20 21.1046 19.1046 22 18 22H6C4.89543 22 4 21.1046 4 20V12C4 10.8954 4.89543 10 6 10H7V7C7 4.23858 9.23858 2 12 2ZM6 20H18V12H6V20ZM12 4C10.3431 4 9 5.34315 9 7V10H15V7C15 5.34315 13.6569 4 12 4Z"
      fill={color}
    />
  </svg>
);
